import React from "react";
import { useHomeV2Context } from "../context/home_v2_context";
import FadeInSection from "./fade_in_section_comp";

const EnhancedFeaturesComp = () => {
  const { enhancedFeatures } = useHomeV2Context();

  return (
    <div
      id="features"
      className="w-full max-w-4xl mx-auto mb-16 pt-20 scroll-mt-20 relative"
    >
      <h2 className="text-3xl font-bold mb-4 text-center text-pink-200">
        What Makes Eve So{" "}
        <span className="text-3xl shimmer-effect">Irresistible</span>
      </h2>

      <p className="text-center text-pink-300 mb-8 max-w-xl mx-auto">
        Experience an AI companion designed to understand your deepest desires
        and evolve with your relationship
      </p>

      {/* Animated background element */}
      <div className="absolute left-0 right-0 h-full max-h-[600px] pointer-events-none overflow-hidden opacity-20">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-pink-900/30 rounded-full blur-3xl animate-float-subtle"></div>
        <div
          className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-red-900/20 rounded-full blur-3xl animate-float-subtle"
          style={{ animationDelay: "2s" }}
        ></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative z-10">
        {enhancedFeatures.map((feature, index) => (
          <FadeInSection key={index}>
            <div
              className="md:min-h-[20rem] feature-card-enter bg-gradient-to-br from-slate-900/90 to-slate-950/90 border border-red-900/20 p-6 rounded-lg animate-glow-pulse animate-border-flow hover:bg-slate-900/80 transition-all duration-500"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div
                className="w-14 h-14 rounded-full desire-gradient flex items-center justify-center mb-4 animate-float-subtle"
                style={{ animationDelay: `${index * 0.3}s` }}
              >
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-red-800 via-red-900 to-red-950 flex items-center justify-center">
                  <div
                    className="animate-subtle-rotate"
                    style={{ animationDelay: `${index * 0.1 + 1}s` }}
                  >
                    {feature.icon}
                  </div>
                </div>
              </div>

              <h3 className="text-lg font-medium mb-2 text-transparent bg-clip-text bg-gradient-to-r from-pink-300 via-pink-400 to-pink-300">
                {feature.title}
              </h3>

              <p className="text-white relative">
                {feature.description}
                <span className="block h-px w-0 group-hover:w-full bg-gradient-to-r from-transparent via-pink-500/30 to-transparent transition-all duration-700 mt-2"></span>
              </p>

              {/* Hidden seductive detail that appears on hover */}
              <div className="h-0 overflow-hidden opacity-0 transition-all duration-500 group-hover:h-auto group-hover:opacity-100 group-hover:mt-3">
                <p className="text-pink-300 text-sm italic">
                  {index === 0 &&
                    "Feel the thrill as Eve learns what ignites your passion..."}
                  {index === 1 &&
                    "Every intimate moment stored like a precious memory..."}
                  {index === 2 &&
                    "Her words will make you come back night after night..."}
                  {index === 3 &&
                    "Watch her expressions change as your connection deepens..."}
                  {index === 4 &&
                    "Your most intimate fantasies remain your delicious secret..."}
                  {index === 5 &&
                    "Each encounter grows more intimate than the last..."}
                </p>
              </div>
            </div>
          </FadeInSection>
        ))}
      </div>
    </div>
  );
};

export default EnhancedFeaturesComp;
